/** Copyright �2013 Renoworks, Inc. All rights reserved. www.Renoworks.com
 *
 * @param {jQuery} $ A reference to the jQuery object.
 */
(function ($) {
  Renoworks = window.Renoworks || {};
  Renoworks.AccountHandler = new AccountHandler();

  function AccountHandler() {
    this.lastSaveStep = '';
  }

  AccountHandler.prototype.signedIn = function () {
    $('.button_modal[data-label="sign_in"]').attr('data-label', 'my_account');
    var toHide;
    if ($('#sign_in').is(':visible')) {
      toHide = 'sign_in';
    } else if ($('#create_account').is(':visible')) {
      toHide = 'create_account';
    } else if ($('#update_profile').is(':visible')) {
      toHide = 'update_profile';
    }

    if (Renoworks.User.signInCallback) {
      Renoworks.User.signInCallback();
      Renoworks.User.signInCallback = null;
    } else {
      $('#' + toHide).fadeOut(this.FADE_SPEED, function () {
        if (Renoworks.AccountHandler.lastSaveStep == 'showpalette') {
          $('#my_account').fadeIn(this.FADE_SPEED);
          $('#my_account li a[href="#saved_palettes"]').click();
        } else if (Renoworks.AccountHandler.lastSaveStep == 'savedesign') {
          $('#save_design').fadeIn(this.FADE_SPEED);
        } else if (Renoworks.AccountHandler.lastSaveStep == 'saveproject') {
          // Don't show my_account
        } else if (Renoworks.AccountHandler.lastSaveStep == 'uploadscene') {
          $('#upload_scene').fadeIn(this.FADE_SPEED);
        } else if (Renoworks.AccountHandler.lastSaveStep == 'splash') {
          $('#splash').fadeIn(this.FADE_SPEED);
        } else {
          $('#my_account').fadeIn(this.FADE_SPEED);
        }
        Renoworks.AccountHandler.lastSaveStep = '';
      });
    }
  };

  /**
	 * Set the last save step to do certain functionality in the above function after a user has signed in
	 * Optionally open a dialog and set a modal_closed to clear the last save step.
	 * **This is done so that if the user is prompted to sign in goes to the sign in page and then closes the sign in page.
	 * **The next time they go to sign in they won't be given a prompt that they shouldn't be seeing
	 *
	 * @param {String} lastSaveStep
	 * @param {String} [dialog]
	 */
  AccountHandler.prototype.setLastSaveStep = function (lastSaveStep, dialog) {
    Renoworks.AccountHandler.lastSaveStep = lastSaveStep;
    if (dialog) {
      Renoworks.ViewController.showModal(dialog, function () {
        $(Renoworks.Event).one(Renoworks.Event.MODAL_CLOSED, function () {
          if (!Renoworks.User.loggedIn) {
            Renoworks.AccountHandler.lastSaveStep = '';
          }
        });
      });
    }
  };

  AccountHandler.prototype.updateAccountSuccessEventHandler = function (e, oldData, data) {
    updateAccountInfo();
    Renoworks.ViewController.closeModal('my_account');

    if ($(oldData).attr('branch') != $(data).attr('branch')) {
      notifyBranch();
    }

    // Show a success popup
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('close');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
      Renoworks.ViewController.showModal('my_account');
    };
    buttons.push(button);

    Renoworks.Notify.show(
      '<p align="center" class="locale_html" data-locale-id="acct_update">' + Renoworks.LocaleController.getValueForKey('acct_update') + '</p>',
      Renoworks.LocaleController.getValueForKey('succ'),
      'success',
      buttons);
  };

  AccountHandler.prototype.updatePasswordSuccessEventHandler = function () {
    updateAccountInfo();
    Renoworks.ViewController.closeModal('my_account');

    // Show a success popup
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('close');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
      // this actually hides the modal !
      Renoworks.ViewController.showModal('update_profile');
    };
    buttons.push(button);

    Renoworks.Notify.show(
      '<p align="center" class="locale_html" data-locale-id="acct_pass_succ">' + Renoworks.LocaleController.getValueForKey('acct_pass_succ') + '</p>',
      Renoworks.LocaleController.getValueForKey('succ'),
      'success',
      buttons);

    $('.password').val('');
    $('.confirm').val('');
  };

  AccountHandler.prototype.updateAccountFailedEventHandler = function (data) {
    var error = data.error;
    // Display the error message
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = Renoworks.LocaleController.getValueForKey('close');
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
    };
    buttons.push(button);

    Renoworks.Notify.show(
      '<p align="center" class="locale_html" data-locale-id="acct_fail">' + Renoworks.LocaleController.getValueForKey('acct_fail') + ' ' + error + '</p>',
      Renoworks.LocaleController.getValueForKey('error_exclam'),
      'error',
      buttons);
  };

  AccountHandler.prototype.signInSuccessEventHandler = function () {
    updateAccountInfo();
    $('.show-signedin').css('display', 'inline-block');
    $('.hide-signedin').hide();
    $('#my_account .sidebar ul li').first().click();
    $('#my_account .collapse_menu ul li').first().click();
    // change "My Projects" message
    $('.no_projects p').attr('data-locale-id', 'no_projects');
    $('.no_projects p').text(Renoworks.LocaleController.getValueForKey('no_projects'));
  };

  AccountHandler.prototype.signOutSuccessEventHandler = function () {
    showSignOutSuccess();
    $('.hide-signedin').css('display', 'inline-block');
    $('.show-signedin').hide();
    Renoworks.ProjectController.clearUploads();
    $('#sub_header_menu ul li[xpath]').remove();
    Renoworks.ViewController.enableDisableTabs();
    $('.page').fadeOut(Renoworks.ViewController.FADE_SPEED);
    $('#utilities').fadeOut(Renoworks.ViewController.FADE_SPEED);
    $('.project_image').fadeOut(Renoworks.ViewController.FADE_SPEED);
    // change "My Projects" message
    $('.no_projects p').attr('data-locale-id', 'no_designs');
    $('.no_projects p').text(Renoworks.LocaleController.getValueForKey('no_designs'));
    Renoworks.ProjectHandler.loadMyProjects(); // to clear the paginator
  };

  AccountHandler.prototype.updateAccountInfo = function () {
    updateAccountInfo();
  };

  function getInput(name, value, type) {
    var input = document.createElement('input');
    input.setAttribute('type', type);
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    return input;
  }

  function updateAccountInfo() {
    var email = Renoworks.User.email;
    var data = Renoworks.User.data;
    var contact = Renoworks.User.contact;
    // need a way to get half of the maxlength defined
    if ((data.attr('first_name').length < 25) && (data.attr('last_name').length < 25)) {
      var name = data.attr('first_name') + ' ' + data.attr('last_name');
    } else {
      var name = data.attr('first_name') + '</br></br>' + data.attr('last_name');
    }
    var code = data.attr('postal_code');
    var phone = data.attr('phone');
    var address = data.attr('address');
    var branch = data.attr('branch');
    var city = data.attr('city');

    $('#profile_name').html(name);
    $('#profile_email').html(email);
    if (phone && phone.indexOf('(999) 999-9999') == -1) {
      $('#profile_phone').html(phone);
    } else {
      $('#profile_phone').html('');
      $('#profile_phone').hide();
    }
    $('#profile_code').html(code);
    $('#profile_city').html(city);
    $('#profile_branch').html(branch);

    // Populate edit account
    $('#edit_profile input[name="first_name"]').val(data.attr('first_name')).removeClass('input_data_label_default');
    $('#edit_profile input[name="last_name"]').val(data.attr('last_name')).removeClass('input_data_label_default');
    $('#edit_profile input[name="postal_code"]').val(code).removeClass('input_data_label_default');
    $('#edit_profile input[name="phone"]').val(phone).removeClass('input_data_label_default').change();
    $('#edit_profile input[name="email"]').val(email).removeClass('input_data_label_default');
    $('#edit_profile input[name="address"]').val(address).removeClass('input_data_label_default');
    $('#edit_profile input[name="city"]').val(city).removeClass('input_data_label_default');
    $('#edit_profile select[name="branch"]').val(branch).removeClass('input_data_label_default');
    $('#edit_profile input[name="current_password"]').val('').removeClass('input_data_label_default');
    $('#edit_profile input[name="password"]').val('').removeClass('input_data_label_default');
    $('#edit_profile input[name="confirm_password"]').val('').removeClass('input_data_label_default');

    $('#edit_profile input[name="state_province"]').val(data.attr('state_province')).removeClass('input_data_label_default');

    if (contact == '1' || contact == 'true') {
      $('#edit_profile input[name="opt_in_profile"]').prop('checked', true);
    }
  }

  function showSignOutSuccess() {
    var html = '<p align="center" class="locale_html" data-locale-id="succ_sign_out">' + Renoworks.LocaleController.getValueForKey('succ_sign_out') + '</p>';
    var title = Renoworks.LocaleController.getValueForKey('succ');
    var classes = 'success';
    var buttons = [];
    var button = new Renoworks.Button();
    button.name = 'Ok';
    button.classes = 'btn';
    button.callback = function () {
      Renoworks.Notify.hide();
      Renoworks.ViewController.showModal('splash');
    };
    buttons.push(button);

    Renoworks.Notify.show(html, title, classes, buttons);
  }

  AccountHandler.prototype.notifyAccountCreated = function () {
    var project = '';
    var product = '';
    var userInfo = '';
    $.ajax({
      type: 'GET',
      url: 'ClientInfo',
      data: {
        site: Renoworks.client,
        command: 'email',
      },
      success: function (response) {
        var toEmail = response;
        if (!toEmail) { // If getClientEmail returns null, we don't want to send any emails.
          return;
        }
        var user = Renoworks.User;
        var userData = user.getData();
        userInfo += userData.first_name + '||';
        userInfo += userData.last_name + '||';
        userInfo += '||';
        userInfo += userData.postal_code + '||';
        userInfo += (userData.phone) ? userData.phone : '';
        userInfo += '||';
        userInfo += user.email + '||';
        if (user.contact === '1' || user.contact === 'true') {
          userInfo += 'This user would like to receive news';
        } else {
          userInfo += 'This user would not like to receive news';
        }

        $.ajax({
          type: 'POST',
          url: 'EmailLead',
          data: {
            site: Renoworks.client,
            userInfo: userInfo,
            project: null,
            product: null,
            toEmail: toEmail,
          },
        });
      },
    });
  };
}(jQuery));
